import { updateDoc, doc } from "firebase/firestore";
import { commentsCollection } from "../../../lib/firebase/firestore";

export const setCommentTreated = async (commentId: string) => {
  const commentRef = doc(commentsCollection, commentId);
  return updateDoc(commentRef, { treated: true });
};
